module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "panel"
  }, [_c('el-col', {
    staticClass: "panel-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticStyle: {
      "font-size": "26px"
    },
    attrs: {
      "span": 20
    }
  }, [_c('i', {
    staticClass: "logo iconfont icon-computer"
  }), _vm._v("\n\t\t\t\t大型仪器外借管理系统\n\t\t\t")]), _vm._v(" "), _c('el-col', {
    staticClass: "rightbar",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "color": "#c0ccda",
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "panel-center",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    staticStyle: {
      "width": "180px"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "theme": "dark",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child, index) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: index,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "panel-c-c"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticStyle: {
      "width": "200px",
      "float": "left",
      "color": "#475669"
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "background-color": "#fff",
      "box-sizing": "border-box"
    },
    attrs: {
      "span": 24
    }
  }, [_c('router-view')], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-161a1b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 527
// module chunks = 1